import { render, staticRenderFns } from "./mainFreestar.vue?vue&type=template&id=0205e232&scoped=true&"
import script from "./mainFreestar.vue?vue&type=script&lang=js&"
export * from "./mainFreestar.vue?vue&type=script&lang=js&"
import style0 from "./mainFreestar.vue?vue&type=style&index=0&id=0205e232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205e232",
  null
  
)

export default component.exports